import { AnyAction, combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import homepage from './homepageReducer'
import restaurantDetails from './restaurantDetailsReducer'
// import { HYDRATE } from 'next-redux-wrapper'
import footer from './footerReducer'
import auth from './authReducer'
import cart from './cartReducer'
import order from './orderReducer'
import forgotPassword from './forgotPasswordReducer'
import orderDetails from './orderDetailReducer'
import serviceDeliveryOptions from './serviceDeliveryOptionsReducer'
import serviceList from './serviceListReducer'
import user from './userReducer'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['cart', 'auth']
}

export const rootReducer = combineReducers({
  homepage,
  restaurantDetails,
  footer,
  auth,
  cart,
  order,
  forgotPassword,
  orderDetails,
  user,
  serviceDeliveryOptions,
  serviceList
})

// const reducer = (state: ReturnType<typeof rootReducer>, action: AnyAction) => {
//   if (action.type === HYDRATE) {
//     const nextState = {
//       ...state, // use previous state
//       ...action.payload // apply delta from hydration
//     }
//     return nextState
//   } else {
//     return rootReducer(state, action)
//   }
// }

export type IRootState = ReturnType<typeof rootReducer>
export type TypedDispatch = ThunkDispatch<IRootState, any, AnyAction>
export type TypedThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  IRootState,
  unknown,
  AnyAction
>

export default persistReducer(persistConfig, rootReducer)
